module.exports = __webpack_public_path__ + "media/images/flags/4x3/som-15e9221c372aa85146ae6a39facc7ec1.svg";